import {
  apiUrl,
  LIST_UNIT_FETCH,
  LIST_UNIT_SUCCESS,
  LIST_UNIT_REJECTED,
  LIST_CURRENCY_FETCH,
  LIST_CURRENCY_SUCCESS,
  LIST_CURRENCY_REJECTED,
  GET_DEPARTMENT_FETCH,
  GET_DEPARTMENT_SUCCESS,
  GET_DEPARTMENT_REJECTED,
  GET_LOCATION_FETCH,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_REJECTED,
  GET_BRAND_FETCH,
  GET_BRAND_SUCCESS,
  GET_BRAND_REJECTED,
  LIST_COUNTRIES_FETCH,
  LIST_COUNTRIES_SUCCESS,
  LIST_COUNTRIES_REJECTED,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const getAllCountries = () => {
  return (dispatch) => {
    dispatch({ type: LIST_COUNTRIES_FETCH });
    return httpClient
      .get(`/refs/countries`)
      .then((result) => {
        dispatch({ type: LIST_COUNTRIES_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_COUNTRIES_REJECTED });
      });
  };
};

export const findAllBrand = () => {
  return (dispatch) => {
    dispatch({ type: GET_BRAND_FETCH });
    return httpClient
      .get(`/refs/brands`)
      .then((result) => {
        dispatch({ type: GET_BRAND_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_BRAND_REJECTED });
      });
  };
};

export const findAllDepartment = () => {
  return (dispatch) => {
    dispatch({ type: GET_DEPARTMENT_FETCH });
    return httpClient
      .get(`/refs/departments`)
      .then((result) => {
        dispatch({ type: GET_DEPARTMENT_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_DEPARTMENT_REJECTED });
      });
  };
};

export const fetchLocation = (countryid) => {
  return (dispatch) => {
    dispatch({ type: GET_LOCATION_FETCH });
    return httpClient
      .get(`/refs/locations/${countryid}`)
      .then((result) => {
        dispatch({ type: GET_LOCATION_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_LOCATION_REJECTED });
      });
  };
};

export const fetchUnit = () => {
  return (dispatch) => {
    dispatch({ type: LIST_UNIT_FETCH });
    return httpClient
      .get(`/refs/units`)
      .then((result) => {
        dispatch({ type: LIST_UNIT_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_UNIT_REJECTED });
      });
  };
};

export const fetchCurrencies = (baseid) => {
  return (dispatch) => {
    dispatch({ type: LIST_CURRENCY_FETCH });
    return httpClient
      .get(`/refs/currencies/${baseid}`)
      .then((result) => {
        dispatch({ type: LIST_CURRENCY_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_CURRENCY_REJECTED });
      });
  };
};
